import React, { useState, useEffect } from 'react';
import './App.css';

function Home() {
  return (
    <>
      {/* Hero Section */}
      <header id="home" className="hero-section" style={{
        background: `linear-gradient(rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75)), url(https://static.wixstatic.com/media/84770f_fb2f87b6e44e4f0cb24eddedb93c4345~mv2.jpg/v1/fill/w_1960,h_1103,enc_auto/file.jpeg) no-repeat center center/cover`
      }}>
        <div className="hero-content">
          <div className="promo-box" style={{ 
            '--mobile-bg': `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${process.env.PUBLIC_URL}/images/IMG_0216.jpg) no-repeat center center/cover`
          } as React.CSSProperties}>
            <div className="clinic-promo">
              <h2>10U, 11U &amp; 12U Fall Ball Sign Up</h2>

              <div className="clinic-details">
                <span>Tuesdays &amp; Thursdays</span>
                <span>4:30pm - 6:30pm</span>
                <span>Purissima Park, Los Altos</span>
                <span>Starting August 11th</span>
                <span>Games on Saturday</span>
              </div>

              <p className="clinic-partner">
                Join South Bay Silverbacks fall ball for focused training, team development, and Saturday games.
              </p>

              <a 
                className="featured-link"
                href="https://bit.ly/sbacksbball" 
                target="_blank" 
                rel="noopener noreferrer" 
              >
                Sign Up Now
              </a>
            </div>
          </div>

          <h1>South Bay Silverbacks Baseball</h1>
          <p>Excellence on and off the field.</p>
        </div>
      </header>
    </>
  );
}

function About() {
  return (
      <section id="about" className="about-section" style={{ minHeight: '60vh' }}>
        <h2>About Our Organization</h2>
        <p>
          The South Bay Silverbacks are dedicated to developing young athletes both as 
          baseball players and as individuals. We focus on fundamentals, teamwork, 
          and sportsmanship, preparing our players for the next level of competition.
        </p>

        <div className="coaches-corner" style={{ 
          marginTop: '4rem', 
          backgroundColor: '#111111', 
          color: '#ffffff',
          padding: '3rem', 
          borderRadius: '12px', 
          textAlign: 'left', 
          maxWidth: '900px', 
          marginLeft: 'auto', 
          marginRight: 'auto', 
          boxShadow: '0 15px 30px rgba(0,0,0,0.5)',
          border: '3px solid #c0c0c0'
        }}>
          <h3 style={{ 
            marginBottom: '1.5rem', 
            color: '#c0c0c0', 
            fontSize: '2.5rem',
            borderBottom: '2px solid #444444',
            paddingBottom: '1rem',
            textTransform: 'uppercase',
            letterSpacing: '2px'
          }}>Coach’s Corner</h3>
          <p style={{ marginBottom: '1.5rem', fontSize: '1.1rem', color: '#e0e0e0', fontStyle: 'italic' }}>Hi everyone,</p>
          <p style={{ marginBottom: '1.5rem', fontSize: '1.1rem', color: '#e0e0e0', lineHeight: '1.8' }}>
            My name is Coach Joey and thank you for visiting our site. 
            Any idea why I chose “Silverbacks” as our team logo? When I started coaching travel ball 8 years ago, I noticed at a younger age, the best teams are the ones with the biggest/most athletically developed kids. The kids who threw the hardest and hit the ball a mile with a -5 bat were the best and it wasn’t even close. I called it “Gorilla Baseball”. And if you’re going to hang with gorillas, you might as well be the Silverback.
          </p>
          <p style={{ marginBottom: '1.5rem', fontSize: '1.1rem', color: '#e0e0e0', lineHeight: '1.8' }}>
            When we started Silverbacks, we didn’t have the biggest or the most explosive kids. But we did have kids and a coaching staff who cared and worked hard at the game. As time went on, our undersized 11, 12, and 13 year olds honed their skills and baseball IQ, so that by the time they grew into their bodies at 16, 17, and 18 they could match their craftiness with newfound athleticism.
          </p>
          <p style={{ fontSize: '1.1rem', color: '#e0e0e0', lineHeight: '1.8', fontWeight: 'bold' }}>
            Our philosophy is teach the game and help foster their enjoyment for the game at 10-16u, so we can train and be at our best at 17 and 18.
          </p>
        </div>
      </section>
  );
}

function Coaches() {
  return (
    <div className="coaches-page" style={{ minHeight: '60vh', padding: '4rem 2rem', textAlign: 'center' }}>
      <h2>Meet the Coaches</h2>
      <p style={{ maxWidth: '800px', margin: '0 auto', fontSize: '1.2rem', lineHeight: '1.6', marginBottom: '3rem' }}>
        Our Coaching Staff is filled with Coaches that not only value developing player’s skills, but players love and enjoyment for the game. Most of our Coaches are former players; returning back to their roots and to the program that helped them develop that love for the game.
      </p>

      <div className="coaches-grid">
        <div className="coach-card">
          <div className="coach-avatar"></div>
          <h3>Joey Rogers</h3>
          <p className="coach-title">Head-Coach / Founder</p>
          <div className="coach-bio">
            <p>Coach Joey has been coaching full time for 8 years now. He previously played at West Valley College, Mission College and De Anza College before a string of injuries ended his playing days.</p>
            <p>He has previously coached at Archbishop Mitty High School, CCB, Saratoga High School, and now Prospect High School. His best season as a head coach of Prospect resulted in 2nd Place in League and 3rd place in CCS Division 6 playoffs.</p>
            <p>In his free time he likes to golf and spend time with his family.</p>
          </div>
        </div>
        <div className="coach-card">
          <div className="coach-avatar"></div>
          <h3>Matthew Perez</h3>
          <p className="coach-title">Assistant Coach</p>
          <div className="coach-bio">
            <p>Coach Matthew is one of the original Silverbacks, playing on the first team in the summer of 2021. He played at Archbishop Mitty High School and graduated in 2024.</p>
            <p>This is his 2nd season coaching the Silverbacks and his first season with Prospect High School.</p>
            <p>He is currently in college and studying to become a physical therapist.</p>
          </div>
        </div>
        <div className="coach-card">
          <div className="coach-avatar"></div>
          <h3>Ellis Lubiens</h3>
          <p className="coach-title">Assistant Coach</p>
          <div className="coach-bio">
            <p>Coach Ellis was Coach Joey’s first hitting lesson in January of 2018. Ellis has gone on win 1st Team All League Honors at Prospect High School and is currently the starting Short Stop at Cabrillo College in Santa Cruz, Ca.</p>
          </div>
        </div>
        <div className="coach-card">
          <div className="coach-avatar"></div>
          <h3>Ray Molina</h3>
          <p className="coach-title">Assistant Coach</p>
          <div className="coach-bio">
            <p>His passion for development, attention to detail, and commitment to players is exactly what our program is about.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function SignUp() {
  return (
    <div className="signup-page">
      <h2>Sign Up</h2>
      <div className="signup-card clinic-promo">
        <p className="clinic-kicker">Fall Skills Clinics</p>
        <h3>Skills Clinics this Fall</h3>

        <div className="clinic-details">
          <span>Sundays</span>
          <span>September - November</span>
          <span>2 hours: skills + games</span>
          <span>Ages 6 - 12</span>
        </div>

        <p className="clinic-partner">
          Powered by Los Altos Little League and Silverbacks Baseball
        </p>

        <a 
          className="featured-link"
          href="https://docs.google.com/forms/d/e/1FAIpQLSfHRAC_XLlfs-nEoi-wPXIJ7vOUdnP5BXKsSze8_W4TH4CQBw/viewform" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          Sign Up Now
        </a>
      </div>

      <div className="signup-card clinic-promo">
        <p className="clinic-kicker">Travel Ball Teams</p>
        <h3>Now Forming 10U, 11U & 12U Teams</h3>

        <p className="clinic-partner">
          Development-focused teams for players ready to grow their skills, compete, and build confidence in a strong team environment.
        </p>

        <a 
          className="featured-link"
          href="https://bit.ly/sbacksbball" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          Secure Your Spot Today
        </a>
      </div>
    </div>
  );
}

function Teams() {
  const ageGroups = ['10U', '11U', '12U', '14U', '16U', '18U'];

  return (
    <div className="teams-page">
      <section className="teams-hero">
        <div className="teams-layout">
          <div className="teams-copy">
            <p className="clinic-kicker">South Bay Silverbacks Teams</p>
            <h2>Our Current Age Groups</h2>
            <p>
              South Bay Silverbacks teams are built around player development, competitive reps, and a consistent coaching approach across age groups.
            </p>

            <div className="age-group-grid" aria-label="Current age groups">
              {ageGroups.map((age) => (
                <div className="age-group-card" key={age}>
                  {age}
                </div>
              ))}
            </div>

            <a className="featured-link" href="https://bit.ly/sbacksbball" target="_blank" rel="noopener noreferrer">
              Ask About a Team
            </a>
          </div>

          <figure className="teams-feature-image">
            <img
              src={`${process.env.PUBLIC_URL}/images/IMG_7239.jpg`}
              alt="South Bay Silverbacks players celebrating together after a tournament"
            />
            <figcaption>18u NCTB State Champions</figcaption>
          </figure>
        </div>
      </section>
    </div>
  );
}

function News() {
  return (
    <div className="news-page" style={{ minHeight: '60vh', padding: '4rem 2rem', textAlign: 'center' }}>
      <h2>Latest News</h2>
      <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'left' }}>
        <div style={{ 
          backgroundColor: '#000000', 
          color: '#ffffff', 
          border: '3px solid #b0b0b0',
          borderRadius: '8px',
          padding: '2rem', 
          marginBottom: '2rem',
          boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
        }}>
          <h3 style={{ fontSize: '1.8rem', marginBottom: '0.5rem', color: '#ffffff', textTransform: 'uppercase', letterSpacing: '1px' }}>Tryouts for Fall 2026</h3>
          <p style={{ fontSize: '0.9rem', color: '#b0b0b0', marginBottom: '1.5rem', fontStyle: 'italic' }}>April 17, 2026</p>
          <div style={{ fontSize: '1.1rem', lineHeight: '1.6', color: '#e0e0e0' }}>
            <p style={{ marginBottom: '1rem' }}>We’re forming 9U, 10U, and 11U teams focused on development, consistency, and building players the right way.</p>
            
            <p style={{ marginBottom: '1rem' }}>Our coaching staff is trained within the same system, so players get clear, consistent instruction no matter who they’re working with. The goal is simple: build strong fundamentals, grow confidence, and help players develop a long-term love for the game while continuing to compete at a high level.</p>
            
            <p style={{ marginBottom: '1rem' }}>If your player is ready to take the next step, we’d love to see them out there.</p>
            
            <p style={{ marginBottom: '1rem', fontWeight: 'bold', color: '#ffffff' }}>Join us at our info session on April 26 or come out for tryouts on May 3.</p>

            <p>
              Reserve your spot: <a href="https://bit.ly/sbacksbball" target="_blank" rel="noopener noreferrer" style={{ color: '#b0b0b0', textDecoration: 'underline', fontWeight: 'bold' }}>bit.ly/sbacksbball</a>
            </p>
          </div>
        </div>

        <div style={{ 
          backgroundColor: '#000000', 
          color: '#ffffff', 
          border: '3px solid #b0b0b0',
          borderRadius: '8px',
          padding: '2rem', 
          marginBottom: '2rem',
          boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
        }}>
          <h3 style={{ fontSize: '1.8rem', marginBottom: '0.5rem', color: '#ffffff', textTransform: 'uppercase', letterSpacing: '1px' }}>Welcome Coach Ellis Lubiens</h3>
          <p style={{ fontSize: '0.9rem', color: '#b0b0b0', marginBottom: '1.5rem', fontStyle: 'italic' }}>March 1, 2026</p>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.6', color: '#e0e0e0' }}>
            We're thrilled to welcome back Ellis Lubiens to the Silverbacks family as an Assistant Coach. After securing 1st Team All League Honors and performing exceptionally at Cabrillo College, he brings a wealth of recent playing experience to our development programs.
          </p>
        </div>
      </div>
    </div>
  );
}

function Gallery() {
  const [selectedImg, setSelectedImg] = useState<string | null>(null);

  const images = [
    'IMG_0002.jpg', 'IMG_0003.jpg', 'IMG_0004 (1).jpg', 'IMG_0004.jpg',
    'IMG_0216.jpg', 'IMG_0217.jpg',
    'IMG_0384.jpg', 'IMG_0392.PNG', 'IMG_0640.jpg', 'IMG_3543.jpg',
    'IMG_6316.jpg', 'IMG_6320.jpg', 'IMG_6323.jpg', 'IMG_6326.jpg',
    'IMG_7239.jpg', 'IMG_8484.jpg', 'IMG_8485.jpg', 'IMG_8486.jpg',
    'IMG_9725.jpg'
  ];

  return (
    <div className="gallery-page" style={{ minHeight: '60vh', padding: '4rem 2rem', textAlign: 'center' }}>
      <h2>Gallery</h2>
      <p style={{ maxWidth: '800px', margin: '0 auto 2rem auto', fontSize: '1.2rem', lineHeight: '1.6' }}>
        Check out photos of our teams in action!
      </p>
      <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '1rem', maxWidth: '1200px', margin: '0 auto' }}>
        {images.map((img, index) => (
          <div 
            key={index} 
            onClick={() => setSelectedImg(img)}
            style={{ 
            width: '300px', 
            height: '250px', 
            backgroundColor: '#1a1a1a', 
            border: '2px solid #333', 
            borderRadius: '8px', 
            overflow: 'hidden', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
            cursor: 'pointer'
          }}>
            <img 
              src={`${process.env.PUBLIC_URL}/images/${img}`} 
              alt={`Silverbacks Baseball Gallery ${index + 1}`} 
              style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.3s ease' }} 
              loading="lazy"
              onMouseOver={e => e.currentTarget.style.transform = 'scale(1.05)'}
              onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
            />
          </div>
        ))}
      </div>

      {/* Lightbox / Modal */}
      {selectedImg && (
        <div className="lightbox-overlay" onClick={() => setSelectedImg(null)}>
          <span className="lightbox-close">&times;</span>
          
          {images.indexOf(selectedImg) > 0 && (
            <span 
              className="lightbox-nav lightbox-prev" 
              onClick={(e) => { e.stopPropagation(); setSelectedImg(images[images.indexOf(selectedImg) - 1]); }}
            >
              &#10094;
            </span>
          )}

          <img 
            src={`${process.env.PUBLIC_URL}/images/${selectedImg}`} 
            className="lightbox-image" 
            alt="Enlarged Gallery View" 
            onClick={(e) => e.stopPropagation()} // Prevent clicking the image from closing the modal
          />

          {images.indexOf(selectedImg) < images.length - 1 && (
            <span 
              className="lightbox-nav lightbox-next" 
              onClick={(e) => { e.stopPropagation(); setSelectedImg(images[images.indexOf(selectedImg) + 1]); }}
            >
              &#10095;
            </span>
          )}
        </div>
      )}
    </div>
  );
}

type PageProps = 'home' | 'coaches' | 'teams' | 'news' | 'gallery' | 'about' | 'signup';

function App() {
  const [currentPage, setCurrentPage] = useState<PageProps>('home');
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsMenuOpen(false); // Close menu when navigating
  }, [currentPage]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
        setIsMenuOpen(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App">
      {/* Navbar Placeholder to prevent layout shift on scroll shrink */}
      <div className="navbar-placeholder"></div>

      {/* Navbar */}
      <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''} ${isMenuOpen ? 'is-menu-open' : ''}`}>
        <div className="navbar-logo">
          <img 
            className="navbar-logo-img" 
            src="https://static.wixstatic.com/media/0eb06f_e96c6374de644cc889601e581d6fbd5a~mv2.png/v1/fill/w_1225,h_1338,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/0eb06f_e96c6374de644cc889601e581d6fbd5a~mv2.png" 
            alt="South Bay Silverbacks Logo" 
            onClick={() => { setCurrentPage('home'); window.scrollTo(0, 0); }} 
            style={{ cursor: 'pointer' }}
          />
          <h2 
            onClick={() => { setCurrentPage('home'); window.scrollTo(0, 0); }} 
            style={{ cursor: 'pointer' }}
          >
            South Bay Silverbacks
          </h2>
        </div>
        
        {/* Hamburger Menu - Mobile navigation toggle */}
        <div 
          className="hamburger-menu show-hamburger"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? '✕' : '☰'}
        </div>

        <ul className={`navbar-links ${!isMenuOpen ? 'hide-on-mobile-scroll' : ''}`}>
          <li><a href="#home" onClick={(e) => { e.preventDefault(); setCurrentPage('home'); window.scrollTo(0, 0); }}>Home</a></li>
          <li><a href="#news" onClick={(e) => { e.preventDefault(); setCurrentPage('news'); }}>News</a></li>
          <li><a href="#coaches" onClick={(e) => { e.preventDefault(); setCurrentPage('coaches'); }}>Coaches</a></li>
          <li><a href="#teams" onClick={(e) => { e.preventDefault(); setCurrentPage('teams'); }}>Teams</a></li>
          <li><a href="#gallery" onClick={(e) => { e.preventDefault(); setCurrentPage('gallery'); }}>Gallery</a></li>
          <li><a href="#about" onClick={(e) => { e.preventDefault(); setCurrentPage('about'); }}>About Us</a></li>
          <li><a href="#signup" onClick={(e) => { e.preventDefault(); setCurrentPage('signup'); }}>Sign Up</a></li>
          <li><a href="#contact" onClick={(e) => { 
            document.getElementById('contact')?.scrollIntoView(); 
            setIsMenuOpen(false);
            e.preventDefault(); 
          }}>Contact</a></li>
        </ul>
      </nav>

      {currentPage === 'home' && <Home />}
      {currentPage === 'about' && <About />}
      {currentPage === 'news' && <News />}
      {currentPage === 'coaches' && <Coaches />}
      {currentPage === 'teams' && <Teams />}
      {currentPage === 'gallery' && <Gallery />}
      {currentPage === 'signup' && <SignUp />}

      {/* Contact / Footer */}
      <footer id="contact" className="footer-section">
        <div className="footer-content">
          <h3>Contact Us</h3>
          <p>Email: sbacksbaseball@gmail.com</p>
          <p>Phone: (408) 204 - 8776</p>
          
          {/* Instagram Icon */}
          <div style={{ marginTop: '1.5rem' }}>
            <a 
              href="https://www.instagram.com/sbacksbaseball/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="instagram-link"
              aria-label="Instagram"
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 24 24" 
                width="32" 
                height="32" 
                fill="currentColor"
              >
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
              </svg>
            </a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} South Bay Silverbacks. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
